module.exports = __webpack_public_path__ + "img/IMG_2493_L_BlackMatted_MockedUp.4ccbd0e6.jpg";